// @flex

import * as React from 'react';
import Box from 'sail/Box';
import Arrow from './Arrow';
import CopyAction from './CopyAction';
import {VERTICAL_SPACING} from './helpers';

const KeyValueRow = ({children, onClick, canCopy, data}) => (
  <Box
    className="KeyValueRow"
    flex={{
      direction: 'row',
      wrap: 'nowrap',
      alignItems: 'baseline',
      justifyContent: 'flex-start',
    }}
    margin={{vertical: VERTICAL_SPACING}}
    style={{
      cursor: onClick ? 'pointer' : 'default',
    }}
    onClick={onClick}
  >
    {!!onClick && (
      <>
        {canCopy && <CopyAction data={data} className="CopyAction--left" />}
        <Arrow
          onClick={onClick}
          style={{transform: 'rotate(-90deg)', top: 5}}
        />
      </>
    )}
    {children}
  </Box>
);

export default KeyValueRow;
